import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';
import { ModalInfo, WsProjectInfo, SourceMoveTo, UserInfo, MoveTo, Methodology } from '../../models';
import { getToolIcon } from 'src/app/resources/tool-utils';
import { PnrrToolService } from '../../services/pnrr-tool.service';

@Component({
    selector: 'app-add-edit-modal-PNRR',
    templateUrl: './add-edit-modal-PNRR.component.html',
    styleUrls: ['./add-edit-modal-PNRR.component.scss'],
    standalone: false
})
export class AddEditModalPNRRComponent implements OnInit {

  @Input() public data: ModalInfo;
  // tslint:disable-next-line: no-output-native
    @Output() submit: EventEmitter<any> = new EventEmitter();
    source: SourceMoveTo;
  collaboratorsList: UserInfo[] = [];
  methodologyList: Methodology;
  collaborator: string;
  name: string;
  destination: MoveTo;
  isChecked = false;
  validation: boolean;
  submitted = false;

    user_role : any = null
  getIcon = getToolIcon;

  constructor(
      public activeModal: NgbActiveModal,
      private pnrr: PnrrToolService
  ) { }

  async ngOnInit() {
      //console.log("some")

      
    if (this.data) {
      this.source = {
        data: this.data as unknown as WsProjectInfo,
        id_parent: this.data.id_parent,
        };
      this.source.data.name_parent = 'Seleziona una cartella'
    // console.log(this.source)

        this.user_role = (await this.pnrr.getRoutingInfo() as any)?.role;

      if (this.data.entityName) {
        this.name = this.data.entityName;

        if (this.data.type_parent !== 'workspace') {
          this.destination = {
            id_entity: this.data.id,
            type: this.data.type,
            new_parent: this.data.id_parent,
            parent_type: this.data.type_parent
          };
        }
        this.validation = false;
      }
    }
  }

    onCreateTemplate() {
        this.submit.emit({ action_type: "template-generator" });
        this.activeModal.close();
    }

    onOpenDashboard() {
        this.submit.emit({action_type : "dashboard"});
        this.activeModal.close();
    }
  /**
   * Get the list of collaborators from the child component
   * @param data Collaborators list
   */

  eventStatusFromChild(data: UserInfo[]) {
    this.collaboratorsList = data;
  }

  /**
   * Get the target of the move to from the child component
   * @param $event Destination
   */

  handleDestination($event: MoveTo) {
    this.destination = $event;
  }

  /**
   * Modal submit. Send the result of the modal to the parent component
   * @param f Form
   */

  onSubmit(f: NgForm) {
    this.submitted = true;
    // tslint:disable-next-line: max-line-length
    const extraFieldIsValid = this.data.selector === 'execution' && !this.destination || this.data.selector === 'scenario' && !this.methodologyList;
    if (f.invalid || extraFieldIsValid) {
      this.validation = extraFieldIsValid;
      return;
    }
    this.submit.emit({
      ...this.data,
      ...f.value,
      id: this.data.id_entity,
      type: this.data.type,
      shared: this.data.collaborators,
      collaborators: this.collaboratorsList,
      checked: this.isChecked,
      destination: this.destination,
        meth: this.methodologyList,
      action_type : "new_execution"
    }
    );
    this.activeModal.close();
  }

  /**
   * Close modal
   */

  onDelete() {
    this.activeModal.close();
  }

  /**
   * Returns the methodology from the child component
   * @param data Methodology
   */

  handleMethodology(data: Methodology) {
    this.methodologyList = data;
    this.validation = false;
  }
}
